import { delay } from '../../../../_augmentt/utils/utils'
import { createHubTask, pollTaskStatus } from '../../../crud/integrationHub.crud'
import { TASK_ACTIONS, TASK_TYPES } from '../../../util/hub-task-management/hub.constants'

const FAILED = 'FAILED'

export async function runBlockSignInTask({ accountEnabled, customerId, organizationId, userId, userIds }) {
  const params = {
    actions: {
      userIds,
      accountEnabled,
    },
    tasktype: TASK_TYPES.blockSignInOnSharedMailboxes,
    action: TASK_ACTIONS.update,
    customerId,
    userId,
    organizationId,
  }

  const taskResponse = await createHubTask(params)
  const { taskId } = taskResponse.data

  // wait 2 seconds before checking the backend so the task can be created
  await delay(2000)

  const pollTask = await pollTaskStatus(taskId, {
    retries: 25,
    timeout: 3000,
  })

  const pollTaskData = JSON.parse(JSON.stringify(pollTask.data))

  // eslint-disable-next-line no-underscore-dangle
  if (pollTaskData._source.status === FAILED) {
    let message = ''
    try {
      const errors = JSON.parse(pollTaskData._source.errors) // eslint-disable-line no-underscore-dangle
      message = errors?.[0]?.message
    } catch (e) {
      // ignore
    }
    throw new Error(message)
  }

  // wait 2 seconds before updating the resource so it can be ingested
  await delay(2000)
}
